import React, {
  useState,
  useEffect,
  useRef,
  ReactNode,
  useCallback,
} from 'react';
import { CSVLink } from 'react-csv';

interface ICsvExportProps {
  filename: string;
  columns: any[];
  data: any[];
  children?: ReactNode;
  disable?: boolean;
  separator?: string;
}

const ReactCSVLink = CSVLink as unknown as React.FC<any>;

const CsvExport: React.FC<ICsvExportProps> = ({
  data,
  filename,
  separator = ';',
  columns,
  children = undefined,
  disable = false,
}) => {
  const [csvData, setCsvData] = useState<any[]>([]);
  const [headers, setHeaders] = useState<any[]>([]);

  const csvInstance = useRef<any>();

  useEffect(() => {
    const instance = csvInstance.current;
    if (csvData?.length > 0 && instance) {
      setTimeout(() => {
        instance?.link.click();
        setCsvData([]);
      });
    }
  }, [csvData]);

  const handleCsv = useCallback(() => {
    if (disable) {
      return;
    }

    const head = columns.map(col => ({ label: col.title, key: col.key }));
    setHeaders(head);

    setCsvData(data);
  }, [columns, data, disable]);

  return (
    <>
      <div style={{ display: 'inline-block' }} onClick={handleCsv}>
        {children}
      </div>
      {csvData ? (
        <ReactCSVLink
          ref={csvInstance}
          data={csvData}
          filename={filename}
          headers={headers}
          separator={separator}
          style={{ position: 'absolute' }}
        />
      ) : undefined}
    </>
  );
};

export default CsvExport;
